<template>
  <div>
    <Modal modal-id="modalClienteFilhosCarteira" title="Contatos da conta" dialog-class="modal-lg">
      <template #body>
        <div v-if="loading" class="text-muted small">Carregando...</div>
        <div v-else-if="error" class="text-danger small">{{ error }}</div>
        <div v-else class="table-responsive">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Nome</th>
                <th>E-mail</th>
                <th>Cargo</th>
                <th>Departamento</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row.id">
                <td>{{ row.nome }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.cargo || "-" }}</td>
                <td>{{ row.departamento || "-" }}</td>
                <td>
                  <a v-if="row.url" :href="row.url" class="small">Abrir</a>
                </td>
              </tr>
              <tr v-if="!rows.length">
                <td colspan="5" class="text-muted small">Nenhum contato vinculado.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template #footer>
        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import Modal from "../ui/Modal.vue";

/** Bootstrap `.modal` está no jQuery global (carregado depois do app.js), não no import do webpack. */
function bs$(selector) {
  const jq = typeof window !== "undefined" ? window.jQuery || window.$ : null;
  if (!jq) {
    return { modal: () => {} };
  }
  return jq(selector);
}

export default {
  name: "ClienteFilhosModal",
  components: { Modal },
  props: {
    filhosPrefix: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      error: "",
      rows: [],
    };
  },
  mounted() {
    window.addEventListener("carteira-abrir-filhos", this.onAbrir);
  },
  beforeDestroy() {
    window.removeEventListener("carteira-abrir-filhos", this.onAbrir);
  },
  methods: {
    onAbrir(e) {
      const id = e && e.detail && e.detail.clienteId;
      if (id) {
        this.carregar(id);
      }
    },
    async carregar(clienteId) {
      this.loading = true;
      this.error = "";
      this.rows = [];
      bs$("#modalClienteFilhosCarteira").modal("show");
      try {
        const url = `${this.filhosPrefix.replace(/\/$/, "")}/${clienteId}/filhos-json`;
        const { data } = await axios.get(url);
        this.rows = data.data || [];
      } catch (err) {
        this.error = "Não foi possível carregar os contatos.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
